import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "sonner";

import HomePage from "./pages/HomePage";
import CheckoutPage from "./pages/CheckoutPage";
import OrdersPage from "./pages/OrdersPage";
import AdminPage from "./pages/AdminPage";
import SSOCallbackPage from "./pages/SSOCallbackPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <div className="App min-h-screen bg-[#0A0A0B]">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/pedidos" element={<OrdersPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/auth/callback" element={<SSOCallbackPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid rgba(255, 255, 255, 0.10)",
                color: "#FFFFFF",
              },
            }}
          />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
